export enum CashRegisterMode {
    CASH_REGISTER_DETAILS = "cash",
    OPERATOR_DETAILS = "operator"
}